import React, { useState, useEffect } from 'react';
import { App, Menu, Spin, notification } from 'antd';
import { getAssetUrl } from '../scripts/cdn';
import { _T } from '../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { Link } from 'react-router-dom';
import { Avatar, Image, Grid, theme } from 'antd';
var Session = apis.sessions.Session;
var useSession = hooks.sessions.useSession;
var useConnectionState = apis.connections.useConnectionState;
var Stream = hooks.streams.Stream;
var DatabaseStateSource = models.server.DatabaseStateSource;
import { clearSessionStorageByPrefix, useUserSettings } from '../hooks/Storage';
import { BugOutlined, MoonOutlined } from '@ant-design/icons';
const { useToken } = theme;
const { useBreakpoint } = Grid;
const BUG_REPORT_EMAIL = 'info@vote4dance.com';
const getBugReportArea = (pathname) => {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length == 0) {
        return 'home';
    }
    if (segments[0] == 'public' && segments[1]) {
        return `public/${segments[1]}`;
    }
    return segments[0];
};
const openBugReportEmail = () => {
    const userInfo = Session.get().getUserInfo();
    const area = getBugReportArea(window.location.pathname);
    const subject = _T('bugReport.subject', { area });
    const body = _T('bugReport.body', {
        area,
        url: window.location.href,
        time: new Date().toISOString(),
        userAgent: window.navigator.userAgent,
        userId: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_id) || '-'
    });
    window.location.href = `mailto:${BUG_REPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
export const LogoMenuItem = (props) => {
    const { token } = useToken();
    const screens = useBreakpoint();
    const [collapsed, setCollapsed] = useState(props.collapsed);
    const { settings } = useUserSettings();
    useEffect(() => {
        setTimeout(() => {
            setCollapsed(props.collapsed);
        }, collapsed ? 250 : 0);
    }, [props.collapsed]);
    const logoContent = (React.createElement(React.Fragment, null,
        React.createElement(Avatar, { style: { margin: 10 }, size: "large", src: getAssetUrl(require('../images/favicon/favicon-96.png')) }),
        !collapsed && screens.md &&
            React.createElement(Image, { width: 200, preview: false, src: getAssetUrl(require(`../images/${settings.theme === 'light' ? 'logo_header_long_dark.png' : 'logo_header_long.png'}`)) })));
    return (React.createElement("div", { style: { backgroundColor: props.disableBackground ? 'transparent' : token.colorBgContainer } },
        React.createElement("a", { href: "/", style: { display: 'flex', alignItems: 'center' } }, logoContent)));
};
export const getUserMenu = () => {
    const sessionState = useSession();
    const userInfo = sessionState && sessionState.userInfo;
    if (userInfo) {
        const name = userInfo.user_firstname + ' ' + userInfo.user_lastname;
        return [{
                label: name,
                key: 'user',
                style: { marginLeft: 'auto' },
                children: [
                    {
                        label: React.createElement(Link, { to: "account" }, _T('header.account')),
                        key: 'account'
                    }, userInfo.federation_count > 0 || userInfo.user_status >= 100 ? {
                        label: _T('header.admin'),
                        key: 'admin'
                    } : {}, userInfo.organization_count > 0 || userInfo.user_status >= 100 ? {
                        label: React.createElement(Link, { to: "organization" }, _T('header.organization')),
                        key: 'organization'
                    } : {},
                    {
                        label: _T('settings.switchTheme'),
                        icon: React.createElement(MoonOutlined, null),
                        key: 'theme'
                    },
                    {
                        label: _T('header.reportBug'),
                        icon: React.createElement(BugOutlined, null),
                        key: 'report_bug'
                    },
                    {
                        label: _T('header.logout'),
                        key: 'logout'
                    }
                ].flat().filter(column => Object.keys(column).length > 0)
            }];
    }
    else if (sessionState && sessionState.sessionInfo && sessionState.sessionInfo.user_id == "0") {
        return {
            label: React.createElement(Link, { to: "login" }, _T('header.login')),
            key: 'user',
            style: { marginLeft: 'auto' }
        };
    }
    else {
        return {
            label: React.createElement(Spin, null),
            key: 'user',
            style: { marginLeft: 'auto' }
        };
    }
};
export const BaseMenu = (props) => {
    const { logo, children, onClick, defaultSelectedKeys } = props;
    const [dbstate, loading, error] = Stream(DatabaseStateSource);
    const { state, isConnected } = useConnectionState();
    const [serverState, setServerState] = useState();
    const { settings, updateSettings } = useUserSettings();
    const { message: appMessage, modal } = App.useApp();
    useEffect(() => {
        if (dbstate && dbstate[0]) {
            var state = dbstate[0].state;
            if (['idle', 'active'].includes(state)) {
                if (serverState != state && serverState != undefined) {
                    state = 'connected';
                    setTimeout(() => {
                        setServerState(undefined);
                    }, 2000);
                }
                else {
                    state = undefined;
                }
            }
            setServerState(state);
        }
    }, [dbstate]);
    useEffect(() => {
        if (state == 'connecting') {
            if (state != undefined) {
                return;
            }
        }
        setServerState(state);
    }, [state]);
    const items = [
        logo ? {
            label: React.createElement(LogoMenuItem, { key: "logo", disableBackground: logo }),
            key: 'logo',
        } : {},
        children ? children : {},
        getUserMenu(),
    ].flat().filter(column => Object.keys(column).length > 0);
    const handleMenuClick = (e) => {
        if (e.key == 'account') {
            const origin = window.location.origin;
            var newLocation = `${origin}/public/account`;
            window.location.href = newLocation;
        }
        else if (e.key == 'admin') {
            const origin = window.location.origin;
            var newLocation = `${origin}/admin-react`;
            window.location.href = newLocation;
        }
        else if (e.key == 'theme') {
            updateSettings({
                ...settings,
                theme: (!settings.theme || settings.theme === 'dark') ? 'light' : 'dark'
            });
            return;
        }
        else if (e.key == 'report_bug') {
            openBugReportEmail();
            return;
        }
        else if (e.key == 'logout') {
            modal.confirm({
                title: _T('header.logout'),
                content: _T('common.confirm'),
                onOk() {
                    clearSessionStorageByPrefix("judge-pin:");
                    const userInfo = Session.get().getUserInfo();
                    if (userInfo) {
                        Session.get().logout()
                            .catch(() => {
                            notification.error({
                                message: _T("logout.failed"),
                                placement: 'topRight'
                            });
                        });
                    }
                }
            });
            return;
        }
        if (e.key === 'logo') {
            return;
        }
        // Allow child menu click
        if (onClick) {
            onClick(e.key);
        }
    };
    useEffect(() => {
        if (serverState) {
            appMessage.destroy();
            const messageType = serverState === 'connected'
                ? 'success'
                : serverState === 'connecting'
                    ? 'loading'
                    : 'error';
            appMessage.open({
                type: messageType,
                content: _T('server.state.' + serverState),
                key: 'server-state',
                duration: 0,
            });
        }
        else {
            appMessage.destroy('server-state');
        }
    }, [appMessage, serverState]);
    return (React.createElement(Menu, { mode: "horizontal", defaultSelectedKeys: defaultSelectedKeys, style: { backgroundColor: 'transparent' }, items: items, onClick: handleMenuClick }));
};
BaseMenu.defaultProps = {
    logo: false
};
